import { useState, useEffect } from "react";

export const TimeIndicator = () => {
    const getTimeString = () => new Date().toLocaleString("en-GB").replace(/\//g, ".");
    const [timeString, setTimeString] = useState(getTimeString());
    const [mountTime] = useState(() => Date.now());
    const [relativeLabel, setRelativeLabel] = useState("just now");

    useEffect(() => {
        const dateTimer = setInterval(() => {
            setTimeString(getTimeString());

            const elapsed = Math.floor((Date.now() - mountTime) / 1000);
            if (elapsed < 60) {
                setRelativeLabel("just now");
            } else if (elapsed < 3600) {
                const mins = Math.floor(elapsed / 60);
                setRelativeLabel(`${mins} min ago`);
            } else {
                const hrs = Math.floor(elapsed / 3600);
                setRelativeLabel(`${hrs}h ago`);
            }
        }, 1000);

        return () => clearInterval(dateTimer);
    }, [mountTime]);

    return <span title={timeString}>{relativeLabel} · {timeString}</span>;
};
